export default [{
  title: 'Ma messagerie',
  icon: 'MailIcon',
  route: 'messageries',
  tag: 3,
  tagVariant: 'light-info',
  typeUser: 'courtier',
}]
